module.exports = {"id":"s4-q1","text":"Do you routinely use the internet to access news, entertainment or other services?","multiselect":false,"options":[{"id":"s4-q1-a1","text":"Yes","capability":2,"access":2,"next":"s4-q2","focusarea":[3,0,0,0,0]},{"id":"s4-q1-a2","text":"No","next":"s4-q1a","capability":0,"access":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dlrq/questions/s4-q1.json
// module id = 917
// module chunks = 32